import $ from 'jquery';
import Modal from '~/modal';
import Ajax from '~/components/Ajax';
import Vue from 'vue';
import {
	Countdown,
	EVENT_COUNTDOWN_ENDED,
} from '~/Countdown';
import { InputPhoneMaskRU } from '~/components/InputPhoneMask';

const COUNTDOWN_DURATION_ISO = 'PT1M';

/**
 * Trigger focus to next code input
 * @param {Event} event
 */
 function focusNext({ currentTarget: input }) {
	const { name, value } = input;

	if (!value)
		return;

	/** @type {RadioNodeList} */
	const inputs = input.form[name];
	const next = Array.from(inputs).indexOf(input) + 1;

	if (next < inputs.length)
		inputs.item(next).focus();
}

const FormStatus = ({ props: { visible, message, type }, data }) => visible ? (
	<div
		class={{
			'form__status': true,
			'form__status_centered': true,
			'form__status_type_success': type === 'success',
			'form__status_type_fail': type === 'fail',
			'form__status_visible': true,
		}}
		{ ...data }
	>
		{ message }
	</div>
) : null;

const GetCodeButton = ({ data }) => (
	<button class="button button_theme_secondary button_block_yes modal-auth__button form__submit" type="submit" { ...data }>
		Получить код
	</button>
)

const initialStatus = {
	visible: false,
	type: null,
	message: null,
}

export const ModalAuthPhone = {
	data: () => ({
		countdownIsTicking: false,
		phone: '+7',
		stage: 1,
		status: Object.assign({}, initialStatus),
	}),
	mixins: [Ajax],
	methods: {
		reset() {
			this.countdownIsTicking = false;
			this.phone = '+7';
			this.stage = 1;
			this.status = Object.assign({}, initialStatus);
		},
		onSubmitPhone(event) {
			event.preventDefault();

			if (this.requestInProgress)
				return;

			const data = $(event.currentTarget).serialize();

			this.makeRequest({
				url: this.$options.apiGetCode,
				method: 'POST',
				data,
			})
				.then(this.onDoneSubmitPhone)
				.catch(this.onFailSubmit);
		},
		onDoneSubmitPhone() {
			this.countdownIsTicking = true;
			this.stage = 2;
			this.$nextTick(() => {
				this.$refs.countdown.$on(EVENT_COUNTDOWN_ENDED, () => this.countdownIsTicking = false)
			});
		},
		onSubmitCode(event) {
			event.preventDefault();

			if (this.requestInProgress)
				return;

			/** @type {HTMLFormElement} */
			const form = event.currentTarget;
			const data = new FormData(form);

			this.makeRequest({
				url: this.$options.apiSendCode,
				method: 'POST',
				data,
				processData: false,
				contentType: false,
			})
				.then(this.onDoneSubmitCode)
				.catch(this.onFailSubmit);
		},
		/**
		 *
		 * @param {object} data
		 * @param {string} textStatus
		 * @param {object} jqXHR
		 */
		onDoneSubmitCode({ success, data: { redirectTo }, error }, textStatus, jqXHR) {
			if (success) {
				if (redirectTo)
					setTimeout(() => location.replace(redirectTo), 1000);
				else
					setTimeout(() => location.reload(), 1000);
			} else {
				this.onFailSubmit(jqXHR, textStatus, error);
			}
		},
		onFailSubmit(jqXHR, textStatus, errorThrown) {
			this.status = Object.assign({}, {
				visible: true,
				type: 'fail',
				message: errorThrown || 'data-fallback',
			});
		},
	},
	mounted() {
		this.$options.apiGetCode = this.$el.dataset.apiGetCode;
		this.$options.apiSendCode = this.$el.dataset.apiSendCode;

		$(this.$el)
			.on('shown.bs.modal', () => focusFirstInput(this.$el))
			.on('hidden.bs.modal', this.reset);
	},
	watch: {
		stage: function (stage, oldStage) {
			const modal = this.$refs.modal;

			if (!modal)
				return;

			if (stage === 1)
				modal.title = 'Вход или регистрация';
			else if (stage === 2)
				modal.title = 'Введите код';

			this.$nextTick(() => focusFirstInput(this.$el));
		},
	},
	render() {
		return (
			<Modal class="modal-auth modal-auth-by-phone" role="dialog" tabindex="-1" aria-hidden="true" initialTitle="Вход или регистрация" ref="modal">
				{ this.stage === 1 ? (
					<form class="form ajax modal-auth-by-phone__form_type_enter-phone" onSubmit={ this.onSubmitPhone }>
						<label class="input-block modal-auth__control">
							<InputPhoneMaskRU class="input-block__input" type="phone" name="LOGIN" value={ this.phone } onInput={ (event) => this.phone = event.currentTarget.value }/>
							<div class="label input-block__label">Телефон</div>
						</label>
						<FormStatus
							class="modal-auth__form-status"
							visible={ this.status.visible }
							type={ this.status.type }
							message={ this.status.message }
						/>
						<GetCodeButton disabled={ this.requestInProgress }/>
					</form>
				) : null }
				{ this.stage === 2 ? (
					<div>
						<form class="form ajax modal-auth-by-phone__form_type_enter-code" onSubmit={ this.onSubmitCode }>
							<div class="modal-auth__control">
								<div class="row">
									{ Array(4).fill(0).map(() => (
										<div class="col">
											<label class="input-block">
												<input
													class="input-block__input input-block__input_centered"
													type="text"
													maxlength="1"
													name="PASSWORD[]"
													onInput={ onInputCode }
													onInput={ focusNext }
												/>
											</label>
										</div>
									)) }
								</div>
							</div>
							<input type="hidden" name="LOGIN" value={ this.phone }/>
						</form>
						<FormStatus
							class="modal-auth__form-status"
							visible={ this.status.visible }
							type={ this.status.type }
							message={ this.status.message }
						/>
						{ (this.countdownIsTicking) ? (
							<div class="modal-auth__timer">
								Получить новый код можно через <Countdown ref="countdown" class="timer" isoDuration={ COUNTDOWN_DURATION_ISO } format="mm:ss">‒‒:‒‒</Countdown>
							</div>
						) : (
							<form onSubmit={ this.onSubmitPhone }>
								<input type="hidden" name="LOGIN" value={ this.phone }/>
								<GetCodeButton disabled={ this.requestInProgress }/>
							</form>
						)}
					</div>
				) : null }
				<ul class="modal-auth__actions"></ul>
			</Modal>
		);
	}
}

function initModalAuthByPhone(modalElement) {
	return new Vue({ el: modalElement });
}

const notDisabled = (input) => input.disabled !== true;
const notHidden = (input) => input.type !== 'hidden';
const notReadOnly = (input) => input.readOnly !== true;
const isVisible = (input) => {
	const { width, height } = input.getBoundingClientRect();

	return width > 0 && height > 0;
}

function focusFirstInput(parent) {
	const inputs = parent.querySelectorAll('input');

	for (const input of inputs) {
		if (notHidden(input) && notDisabled(input) && notReadOnly(input) && isVisible(input)) {
			input.focus();
			break;
		}
	}
}

/**
 *
 * @param {Event} event
 */
 function onInputCode(event) {
	/** @type {HTMLInputElement} */
	const input = event.currentTarget;
	const { name } = input;
	/** @type {RadioNodeList} */
	const inputs = input.form[name];
	let allInputsHasValue = true;

	// Check if all inputs has value
	for (const input of inputs.values()) {
		if (!input.value) {
			// Break the loop if one of them doesn't have
			allInputsHasValue = false;
			break;
		}
	}

	if (allInputsHasValue) {
		const submitEvent = new Event('submit', {
			cancelable: true
		});

		input.form.dispatchEvent(submitEvent);
	}
}


document.addEventListener('DOMContentLoaded', () => {
	const modal = document.querySelector('[is="modal-auth-phone"]');

	if (!modal) return;

	Vue.component('modal-auth-phone', ModalAuthPhone);
	initModalAuthByPhone(modal);
});
